import { ElementType, FC, PropsWithChildren } from 'react';
import Scrollbars, { ScrollbarProps } from 'react-custom-scrollbars-2';

interface Props {
    as?: ElementType;
    className?: string;
}

const scrollbarSettings: ScrollbarProps = {
    autoHide: false,
    universal: false,
    autoHeight: false,
    thumbMinSize: 32,
    autoHeightMin: 0,
    autoHeightMax: 200,
    autoHideTimeout: 1000,
    autoHideDuration: 200,
    hideTracksWhenNotNeeded: false,
};

export const WithScrollBars: FC<Readonly<PropsWithChildren<Props>>> = ({
    as: As = 'div',
    children,
    className,
}) =>
    className ? (
        <As className={className}>
            <Scrollbars {...scrollbarSettings}>{children}</Scrollbars>
        </As>
    ) : (
        <Scrollbars {...scrollbarSettings}>{children}</Scrollbars>
    );

export default WithScrollBars;
